import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const BenefitInfoPageRoute = () => {
	const history = useHistory();

	const [mediaResult, setMediaResult] = useState(false);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const handleChange = (e) => {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", handleChange);
		}
	}, []);

	const blankSpaceStyle = {
		height: "5rem",
		background: "linear-gradient(#ffffff, #e6f2ff)",
	};

	const wrapStyle = {
		display: "flex",
		flexDirection: `${mediaResult ? "column" : "row"}`,
		justifyContent: "center",
		alignItems: "center",
		padding: `${mediaResult ? "1.5rem 0 3.5rem 0" : "0"}`,
		gap: `${mediaResult ? "1.5rem" : "0"}`,
		width: "100%",
		height: `${mediaResult ? "100%" : "20rem"}`,
	};

	const wrapInnerStyle = {
		width: `${mediaResult ? "100%" : "50%"}`,
		maxWidth: `${mediaResult ? "300px" : "none"}`,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: `${mediaResult ? "0" : "1.5rem"}`,
		cursor: "pointer",
	};

	const imgWrapStyle = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: `${mediaResult ? "80%" : "auto"}`,
		height: `${mediaResult ? "auto" : "11rem"}`,
	};

	const routeToQnA = () => {
		window.open(`https://www.dangyoung.com/mypage/inquiry/counsel`);
	};

	const routeToFAQ = () => {
		history.push("/faq");
		// window.open(`${process.env.REACT_APP_HOST}/faq`);
	};

	return (
		<div>
			<div style={blankSpaceStyle} />
			<div style={{ backgroundColor: "#e6f2ff" }}>
				<h3
					style={{
						marginBottom: 0,
						padding: "1rem 0",
						textAlign: "center",
						fontSize: "2rem",
						fontWeight: "600",
					}}
				>
					궁금한 점이 있으신가요?
				</h3>
				<div style={wrapStyle}>
					<div style={wrapInnerStyle} onClick={routeToQnA}>
						<div style={imgWrapStyle}>
							<img
								src={`/assets/images/benefit/info-icon-1.png`}
								alt={`qna-icon`}
								style={{
									width: `${mediaResult ? "7.5rem" : "inherit"}`,
									height: "inherit",
									// height: `${mediaResult ? "inherit" : "11rem"}`,
									objectFit: "cover",
									border: "none",
								}}
							/>
						</div>
						<div style={{ width: `${mediaResult ? "100%" : "auto"}` }}>
							<h4
								style={{
									marginBottom: 0,
									paddingBottom: `0.5rem`,
									fontSize: "1.75rem",
									fontWeight: "600",
								}}
							>{`1:1 문의하기 >`}</h4>
							<p style={{ color: "#868788", fontSize: "1.25rem" }}>
								궁금한 점이 있으시다면
							</p>
							<p style={{ color: "#868788", fontSize: "1.25rem" }}>
								언제든 문의해 주세요!
							</p>
						</div>
					</div>
					<div
						style={{
							backgroundColor: "#cbcfd3",
							width: `${mediaResult ? "70%" : "1px"}`,
							height: `${mediaResult ? "1px" : "70%"}`,
						}}
					/>
					<div style={wrapInnerStyle} onClick={routeToFAQ}>
						<div style={imgWrapStyle}>
							<img
								src={`/assets/images/benefit/info-icon-2.png`}
								alt={`faq-icon`}
								style={{
									width: `${mediaResult ? "5rem" : "inherit"}`,
									height: "inherit",
									// height: `${mediaResult ? "auto" : "inherit"}`,
									objectFit: "cover",
									border: "none",
								}}
							/>
						</div>
						<div style={{ width: `${mediaResult ? "100%" : "auto"}` }}>
							<h4
								style={{
									marginBottom: 0,
									paddingBottom: `0.5rem`,
									fontSize: "1.75rem",
									fontWeight: "600",
								}}
							>{`자주 묻는 질문 >`}</h4>
							<p style={{ color: "#868788", fontSize: "1.25rem" }}>
								궁금한 질문을
							</p>
							<p style={{ color: "#868788", fontSize: "1.25rem" }}>
								바로 해결하세요!
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BenefitInfoPageRoute;
